<div
  class="dropdown"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="header" *ngIf="title">
    <h3 class="title">{{ title }}</h3>
  </div>
  <div class="body">
    <ng-content></ng-content>
  </div>
  <div class="footer"></div>
</div>
